import { useCallback } from 'react';
import useUrlBuilder from '@/util/useUrlBuilder';
import { useHasEquipmentPermit } from '@/view/fleet/utils/useHasEquipmentPermit';
import { equipmentDataFullPath } from '@/view/pathDefinitions';
import type { DateRangeParams } from '../types';

export type ViewRms = (params?: DateRangeParams) => void;

export const useViewRms = (equipmentId: string): ViewRms | undefined => {
  const { buildUrl } = useUrlBuilder();
  const { hasPermit } = useHasEquipmentPermit(equipmentId, 'eqmnt.trends:r');

  const navigate = useCallback(
    (params?: DateRangeParams) => {
      buildUrl(equipmentDataFullPath)
        .setParam('selected', equipmentId)
        .setParam('tab', 'screen_tab_trend')
        .setParam('from', params?.from?.toISOString())
        .setParam('to', params?.to?.toISOString())
        .setAnchor('screen_diagram_root_mean_square')
        .push();
    },
    [buildUrl, equipmentId]
  );

  return hasPermit ? navigate : undefined;
};
